import { useMutation } from '@apollo/client'
import { SetupUserPaymentMethod } from '../../types'
import { SETUP_PAYMENT_METHOD } from './operations'

export const useSetupPaymentMethod = () => useMutation<SetupUserPaymentMethod>(SETUP_PAYMENT_METHOD)
